import { DealUser } from "./deal-user";

/**
 * Represents the data required to share one or more deals with a set of users.
 */
export class DealUserShares {

  /**
   * The list of deal identifiers to be shared.
   */
  dealIds?: string[] | null = null;

  /**
   * The list of deal names corresponding to the deal identifiers.
   */
  dealNames?: string[] | null = null;

  /**
   * The list of users with whom the deals will be shared.
   */
  users?: DealUser[] = [];

  /**
   * True when this share action should only add the given users, leaving any existing
   * shares on the deal(s) untouched. False/omitted replaces the full share list, removing
   * anyone missing from it.
   */
  additiveOnly?: boolean = false;

  /**
   * The deal's creator - when set, the share dialog blocks submission if this user has been
   * unchecked, since the creator can never be removed from their own deal's share list.
   */
  creatorId?: string | null = null;

}


